import options from "./components/qualifying-section/retailer-options";

export const ELEMENTS = {
  PURCHASE_SECTION: "purchaseSection",
  CHECK_QUALIFY: "checkQualify",
  CHECK_QUALIFY_MESSAGE_BOX: "endCheckQualifyMessageBox",
  LOWER_PRICE_RETAILER: "retailerName",
  INFO_RETAILER_MESSAGE: "infoRetailerMessage",
  WARN_AMAZON_RETAILER_MESSAGE: "warnAmazonRetailerMessage",
  WARN_JOHN_LEWIS_RETAILER_MESSAGE: "warnJohnLewisRetailerMessage",
  PURCHASED_FROM: "purchaseType",
  PURCHASED_SHOP: "purchaseLocation",
  PURCHASED_PAYMENT_MODE: "purchasedPaymentMode",
  ERROR_MESSAGE_PAYMENT_MODE: "errorMessagePaymentMode",
  PURCHASED_DATE: "purchaseDate",
  ORIGINAL_PURCHASE_SECTION: "originalPurchaseSection",
  RECEIPT_PHOTOS: "receiptPhotos",
  ORDER_NUMBER: "jlOrderManagementNumber",
  JL_PRODUCT_CODE: "productCode",
  PRODUCT_NAME: "productName",
  PRODUCT_COLOR: "productColor",
  PRICE_PAID_AT_JL: "johnLewisPrice",
  PRICE_TO_MATCH: "competitorPrice",
  SUBMIT_BUTTON: "showSubmitButton",
  CUSTOM_FORM: "customForm",
  LOWER_PRICE_HEADER: "lower-price-header",
  LINK_TO_LOWER_PRICES: "retailerWebsite",
  LOWER_PRICE_PHOTOS: "lowerPricePhotos",
  YOUR_DETAILS_HEADER: "your-details-header",
  USER_TITLE: "customerTitle",
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  PHONE: "suppliedPhone",
  EMAIL: "suppliedEmail",
  POSTCODE: "postcode",
};

const isTruthy = value => !!value;

const matches = (state, element, value) => state[element] === value;

const isNotEmpty = (state, element) => isTruthy(state[element]);

export const shouldShowPurchaseConditionsMessage = state => matches(state, ELEMENTS.CHECK_QUALIFY, "no");

const shouldShowLowerPriceRetailer = state => matches(state, ELEMENTS.CHECK_QUALIFY, "yes");

const isAmazonRetailer = selectedRetailer => {
  const amazonRetailerOptionValue = options[0].value;
  return amazonRetailerOptionValue === selectedRetailer;
};

const isJohnLewisRetailer = selectedRetailer => {
  const johnLewisRetailerOptionValue = options[17].value;
  return johnLewisRetailerOptionValue === selectedRetailer;
};

const shouldShowConfirmRetailerMessage = state => {
  return (
    isNotEmpty(state, ELEMENTS.LOWER_PRICE_RETAILER) &&
    !isAmazonRetailer(state[ELEMENTS.LOWER_PRICE_RETAILER]) &&
    !isJohnLewisRetailer(state[ELEMENTS.LOWER_PRICE_RETAILER]) &&
    matches(state, ELEMENTS.CHECK_QUALIFY, "yes")
  );
};

const shouldShowAmazonRetailerConfirmMessage = state => {
  return (
    isNotEmpty(state, ELEMENTS.LOWER_PRICE_RETAILER) &&
    isAmazonRetailer(state[ELEMENTS.LOWER_PRICE_RETAILER]) &&
    matches(state, ELEMENTS.CHECK_QUALIFY, "yes")
  );
};

const shouldShowJohnLewisRetailerConfirmMessage = state => {
  return (
    isNotEmpty(state, ELEMENTS.LOWER_PRICE_RETAILER) &&
    isJohnLewisRetailer(state[ELEMENTS.LOWER_PRICE_RETAILER]) &&
    matches(state, ELEMENTS.CHECK_QUALIFY, "yes")
  );
};

const shouldShowPurchasedFrom = state =>
  isNotEmpty(state, ELEMENTS.LOWER_PRICE_RETAILER) && matches(state, ELEMENTS.CHECK_QUALIFY, "yes");

const shouldShowPurchasedShop = state => matches(state, ELEMENTS.PURCHASED_FROM, "shop");
export const shouldShowPurchasedOnline = state => matches(state, ELEMENTS.PURCHASED_FROM, "online");

const shouldShowPurchasedPaymentMode = state =>
  shouldShowPurchasedShop(state) && isNotEmpty(state, ELEMENTS.PURCHASED_SHOP);

export const shouldShowErrorMessagePaymentMode = state =>
  shouldShowPurchasedShop(state) && matches(state, ELEMENTS.PURCHASED_PAYMENT_MODE, "cash-or-vouchers-or-gift");

const shouldShowPurchasedDate = state => {
  if (shouldShowPurchasedShop(state) && matches(state, ELEMENTS.PURCHASED_PAYMENT_MODE, "credit-or-debit-card")) {
    return true;
  }
  return shouldShowPurchasedOnline(state);
};

const shouldShowReceiptPhotos = state =>
  isNotEmpty(state, ELEMENTS.PURCHASED_DATE) && shouldShowPurchasedDate(state) && shouldShowPurchasedShop(state);

const shouldShowOrderId = state =>
  isNotEmpty(state, ELEMENTS.PURCHASED_DATE) && shouldShowPurchasedDate(state) && shouldShowPurchasedOnline(state);

const shouldShowRemainingElements = state => shouldShowReceiptPhotos(state) || shouldShowOrderId(state);

const shouldDisplayRequestForm = state => shouldShowPurchasedFrom(state);

const shouldShowLowerPriceSection = state => {
  return (
    shouldShowRemainingElements(state) &&
    state[ELEMENTS.LOWER_PRICE_RETAILER] !== "" &&
    state[ELEMENTS.LOWER_PRICE_RETAILER] !== "John Lewis"
  );
};

const displayConditions = state => {
  const rules = {
    [ELEMENTS.CHECK_QUALIFY]: () => true,
    [ELEMENTS.CUSTOM_FORM]: () => shouldDisplayRequestForm(state),
    [ELEMENTS.SUBMIT_BUTTON]: () => shouldShowRemainingElements(state),
    [ELEMENTS.CHECK_QUALIFY_MESSAGE_BOX]: () => shouldShowPurchaseConditionsMessage(state),
    [ELEMENTS.LOWER_PRICE_RETAILER]: () => shouldShowLowerPriceRetailer(state),
    [ELEMENTS.INFO_RETAILER_MESSAGE]: () => shouldShowConfirmRetailerMessage(state),
    [ELEMENTS.PURCHASED_FROM]: () => shouldShowPurchasedFrom(state),
    [ELEMENTS.PURCHASED_SHOP]: () => shouldShowPurchasedShop(state),
    [ELEMENTS.PURCHASED_PAYMENT_MODE]: () => shouldShowPurchasedPaymentMode(state),
    [ELEMENTS.ERROR_MESSAGE_PAYMENT_MODE]: () => shouldShowErrorMessagePaymentMode(state),
    [ELEMENTS.ORIGINAL_PURCHASE_SECTION]: () => shouldShowPurchasedFrom(state),
    [ELEMENTS.PURCHASED_DATE]: () => shouldShowPurchasedDate(state),
    [ELEMENTS.RECEIPT_PHOTOS]: () => shouldShowReceiptPhotos(state),
    [ELEMENTS.ORDER_NUMBER]: () => shouldShowOrderId(state),
    [ELEMENTS.LOWER_PRICE_HEADER]: () => shouldShowLowerPriceSection(state),
    [ELEMENTS.LOWER_PRICE_PHOTOS]: () => shouldShowLowerPriceSection(state),
    [ELEMENTS.LOWER_PRICE_LINK]: () => shouldShowLowerPriceSection(state),
    [ELEMENTS.WARN_AMAZON_RETAILER_MESSAGE]: () => shouldShowAmazonRetailerConfirmMessage(state),
    [ELEMENTS.WARN_JOHN_LEWIS_RETAILER_MESSAGE]: () => shouldShowJohnLewisRetailerConfirmMessage(state),
  };
  return element => {
    if (rules[element]) {
      return rules[element]();
    } else {
      return shouldShowRemainingElements(state);
    }
  };
};

export default displayConditions;
